module.exports = {
    FAVORITES_GET: 'FAVORITES_GET',
};
